import React from 'react';
import { Star, Quote } from 'lucide-react';

const TestimonialSection = () => {
  const additionalTestimonials = [
    {
      quote: "The reporting capabilities are exactly what we needed. No more manual exports.",
      author: "Sarah M.",
      role: "Partner at Mid-Size CPA Firm"
    },
    {
      quote: "Implementation was smooth and the time savings are incredible.",
      author: "Mike R.",
      role: "Operations Manager"
    },
    {
      quote: "Finally, real-time insights that actually help us make decisions.",
      author: "Jennifer L.",
      role: "Managing Partner"
    }
  ];

  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mb-4 sm:mb-6">
            What CPA Firms Are Saying
          </h2>
          <p className="text-lg sm:text-xl text-gray-600 max-w-3xl mx-auto">
            Join growing firms that have transformed their practice management
          </p>
        </div>
        
        {/* Main Testimonial */}
        <div className="max-w-5xl mx-auto mb-12 sm:mb-16">
          <div className="bg-gray-50 rounded-xl p-6 sm:p-8 lg:p-12 border border-gray-100 text-center">
            <div className="flex items-center justify-center mb-4 sm:mb-6">
              <Quote className="w-10 h-10 sm:w-12 sm:h-12 text-orange-500" />
            </div>
            
            <blockquote className="text-lg sm:text-xl lg:text-2xl xl:text-3xl text-gray-800 font-medium leading-relaxed mb-6 sm:mb-8 italic">
              "We have integrated Practice Dashboard into our weekly management meetings, and it has transformed how we review our performance. Before that, pulling together our key data points was a time-consuming process that often delayed our decision-making. Now, it's available instantly during our meetings. This is a game-changer for me."
            </blockquote>
            
            <div className="text-center">
              <div className="flex justify-center mb-3 sm:mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-4 h-4 sm:w-5 sm:h-5 text-yellow-400 fill-current" />
                ))}
              </div>
              
              <div className="flex flex-col sm:flex-row items-center justify-center space-y-2 sm:space-y-0 sm:space-x-4">
                <div className="bg-orange-100 rounded-full w-10 h-10 sm:w-12 sm:h-12 flex items-center justify-center">
                  <span className="text-orange-600 font-semibold text-sm sm:text-base">HC</span>
                </div>
                <div className="text-center sm:text-left">
                  <p className="font-semibold text-gray-900 text-base sm:text-lg">Happy CPA firm founder</p>
                  <p className="text-sm sm:text-base text-gray-600">Mid-size CPA Firm</p>
                </div>
              </div>
            </div>
          </div>
        </div>
        
        {/* Additional Testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {additionalTestimonials.map((testimonial, index) => (
            <div key={index} className="bg-gray-50 rounded-xl p-4 sm:p-6 border border-gray-100">
              <div className="flex mb-3 sm:mb-4">
                {[...Array(5)].map((_, i) => (
                  <Star key={i} className="w-3 h-3 sm:w-4 sm:h-4 text-yellow-400 fill-current" />
                ))}
              </div>
              
              <p className="text-gray-800 mb-4 sm:mb-6 italic text-base sm:text-lg">"{testimonial.quote}"</p>
              
              <div className="flex items-center space-x-2 sm:space-x-3">
                <div className="bg-orange-100 rounded-full w-6 h-6 sm:w-8 sm:h-8 flex items-center justify-center">
                  <span className="text-orange-600 font-semibold text-xs sm:text-sm">
                    {testimonial.author.split(' ').map(n => n[0]).join('')}
                  </span>
                </div>
                <div>
                  <p className="font-semibold text-gray-900 text-sm sm:text-base">{testimonial.author}</p>
                  <p className="text-xs sm:text-sm text-gray-600">{testimonial.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialSection;